'use strict';
/* eslint no-sync: 0 */
// depreacated
import angular from 'angular';

export class SfNgMessagesDirective {


  constructor() {
    'ngInject';

  }

}

export default angular.module('directives.sfNgMessages', [])
  .directive('sfNgMessages', function () {
    return {
      replace: false,
      require: 'ngMessages',
      template: require('./sf-ng-messages.pug'),
      controller: SfNgMessagesDirective
    }

  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sf-ng-messages/sf-ng-messages.directive.js